module.exports = __webpack_public_path__ + "static/img/wheelBg.d7130fd.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/wheelBg.webp
// module id = nEI6
// module chunks = 0